<template>
  <div class="step">
    <el-row class="row-box">
      <!-- wait / process / finish / error / success el-step__icon-inner -->
      <el-steps :active="activeStep" simple :space="62" process-status="finish" finish-status="wait " class="wrapper">
        <el-step index=""  :title="languageDataObj.myinformation[language]" icon="el-icon-postcard" class="item"></el-step>
        <el-step :title="languageDataObj.myresume[language]" icon="el-icon-tickets" class="item"></el-step>
        <el-step :title="languageDataObj.languagetest[language]" icon="el-icon-document-checked" class="item"></el-step>
        <el-step :title="languageDataObj.mysettlement[language]" icon="el-icon-user" class="item"></el-step>
      </el-steps>
      <div class="linkBox">
        <router-link to='/personalcenter/basicinformation' class="links" tag='div'></router-link>
        <router-link to='/personalcenter/myresume' class="links" tag='div'></router-link>
        <router-link to='/personalcenter/languagetest' class="links" tag='div'></router-link>
        <router-link to='/personalcenter/personalverification' class="links" tag='div'></router-link>
      </div>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "Step",
  props:{
    step:{
      type:Number,
      required:true,
    }
  },
  data() {
    return {
      activeStep:0,
       // language
       languageDataObj:null,

    };
  },
  mounted(){
    this.activeStep = this.step;
  },
  created(){
    
    // 获取浏览器语言类型
    this.backLanguageText('YYStep') 
  },
  watch:{
    // 监听语言变化,并进行回调
    language:function (val, oldVal) {
      // console.log('new: %s, old: %s', val, oldVal)
      this.backLanguageText('YYStep') 
    },
  },
  computed:{
    // 计算监听数据
    language(){
      return  this.$store.state.languageType
    },
    // 获取路由导航
    // getPath(){
    //   return this.$store.state.sidePath
    // }
  },
  methods:{
    // 获取当前语言版本的文字
    backLanguageText(component){
      this.languageDataObj = this.$language.changeLanguageType(this.language,component);
      // console.log('打印语言textoverview页面',this.languageDataObj)
    },
  }
};
</script>
<!-- is-finish is-process -->
<style lang="less">

</style>
<style lang="less" scoped>
.step {
  height: 64px;
  background: #ffffff;
  border-radius: 12px;
  font-family: Arial, Helvetica, sans-serif;
  .wrapper {
    height: 64px;
    background-color: #fff;
    box-sizing: border-box;
    padding: 0 24px;
    border-radius: 12px;
    font-size: 14px;

    .item {
      cursor: pointer;
      font-weight: bold;
    }
  }
  .row-box{
    position: relative;
    .linkBox{
      position: relative;
      top: -48px;
      // float: left;
      height: 30px;
      width: auto;
      // background-color: rgb(235, 120, 120);
      display: flex;
      justify-content: space-between;
      align-items: center;
      .links{
        width: 300px;
        height: 30px;
        // background-color: rgb(167, 241, 29);
      }
    }
  }
}

/deep/
  .el-step.is-simple
  .el-step__icon-inner[class*="el-icon"]:not(.is-status) {
  font-size: 24px;
}
/deep/ .el-step{
  .el-step__title{
    min-width: 150px;
    font-size: 15px;
    // background-color: #c00;
  }
  .el-step__arrow{
    max-width: 100px;
  }
}
</style>